(function () {
  function blockMobileProductLightbox(event) {
    if (!window.matchMedia('(max-width: 989px)').matches) return;

    const mediaButton = event.target.closest('media-gallery modal-opener button, media-gallery .product__media-toggle');

    if (!mediaButton) return;

    const modalOpener = mediaButton.closest('modal-opener');

    if (!modalOpener) return;
    if (!modalOpener.getAttribute('data-modal')) return;
    if (!modalOpener.getAttribute('data-modal').includes('ProductModal')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  document.addEventListener('click', blockMobileProductLightbox, true);
  document.addEventListener('pointerup', blockMobileProductLightbox, true);
})();

(function () {
  function initModelierMediaModal() {
    document.querySelectorAll('product-modal.modelier-media-modal').forEach((modal) => {
      if (modal.dataset.modelierModalReady === 'true') return;

      const content = modal.querySelector('.modelier-modal-content');
      const items = Array.from(modal.querySelectorAll('.modelier-modal-media-item'));
      const thumbs = Array.from(modal.querySelectorAll('.modelier-modal-thumb'));

      if (!content || !items.length || !thumbs.length) return;

      modal.dataset.modelierModalReady = 'true';

      let currentIndex = 0;

      function setActive(index, smooth = true) {
        if (index < 0) index = items.length - 1;
        if (index >= items.length) index = 0;

        currentIndex = index;

        thumbs.forEach((thumb) => thumb.classList.remove('is-active'));

        if (thumbs[currentIndex]) {
          thumbs[currentIndex].classList.add('is-active');
          thumbs[currentIndex].scrollIntoView({
            behavior: smooth ? 'smooth' : 'auto',
            inline: 'center',
            block: 'nearest'
          });
        }

        if (items[currentIndex]) {
          items[currentIndex].scrollIntoView({
            behavior: smooth ? 'smooth' : 'auto',
            block: 'center',
            inline: 'center'
          });
        }
      }

      function go(direction) {
        setActive(currentIndex + direction);
      }

      modal._modelierSetActive = setActive;
      modal._modelierGo = go;

      content.addEventListener('scroll', function () {
        let closestIndex = currentIndex;
        let closestDistance = Infinity;

        items.forEach((item, index) => {
          const rect = item.getBoundingClientRect();
          const distance = Math.abs(rect.top + rect.height / 2 - window.innerHeight / 2);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        currentIndex = closestIndex;

        thumbs.forEach((thumb) => thumb.classList.remove('is-active'));

        if (thumbs[currentIndex]) {
          thumbs[currentIndex].classList.add('is-active');
        }
      });
    });
  }

  function stopControlEvent(event) {
    const control = event.target.closest('.modelier-modal-arrow, .modelier-modal-thumb');
    if (!control) return;

    const modal = control.closest('product-modal.modelier-media-modal');
    if (!modal) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      const control = event.target.closest('.modelier-modal-arrow, .modelier-modal-thumb');
      if (!control) return;

      const modal = control.closest('product-modal.modelier-media-modal');
      if (!modal) return;

      event.stopPropagation();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      const control = event.target.closest('.modelier-modal-arrow, .modelier-modal-thumb');
      if (!control) return;

      const modal = control.closest('product-modal.modelier-media-modal');
      if (!modal) return;

      stopControlEvent(event);

      if (control.classList.contains('modelier-modal-arrow--prev')) {
        modal._modelierGo(-1);
        return;
      }

      if (control.classList.contains('modelier-modal-arrow--next')) {
        modal._modelierGo(1);
        return;
      }

      if (control.classList.contains('modelier-modal-thumb')) {
        const thumbs = Array.from(modal.querySelectorAll('.modelier-modal-thumb'));
        const index = thumbs.indexOf(control);

        if (index >= 0) {
          modal._modelierSetActive(index);
        }
      }
    },
    true
  );

  document.addEventListener(
    'wheel',
    function (event) {
      const modal = event.target.closest('product-modal.modelier-media-modal');
      if (!modal) return;

      const content = modal.querySelector('.modelier-modal-content');
      if (!content) return;

      event.preventDefault();
      content.scrollBy({
        top: event.deltaY,
        behavior: 'auto'
      });
    },
    { passive: false }
  );

  document.addEventListener('DOMContentLoaded', initModelierMediaModal);
  document.addEventListener('shopify:section:load', initModelierMediaModal);
})();